import { render, staticRenderFns } from "./navbarPortal.vue?vue&type=template&id=d37b7960"
import script from "./navbarPortal.vue?vue&type=script&lang=js"
export * from "./navbarPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports